import imageError from '$lib/assets/image-error.png';

import {
	PUBLIC_IPFS_URL,
	PUBLIC_PINATA_GATEWAY_TOKEN
} from '$env/static/public';
import type { AuctionViewData, NftViewData } from './nft/common/types';

export type Image = {
	name: string;
	mediaType?: string;
	src: string;
};

export function getWebImageUrl(url: string | undefined) {
	if (url === undefined) {
		return imageError;
	} else if (
		url.startsWith('http://') ||
		url.startsWith('https://') ||
		url.startsWith('data:image')
	) {
		return url;
	} else if (url.startsWith('ar://')) {
		const id = url.substring(5);
		return `https://arweave.net/${id}`;
	} else {
		const cid = url.replaceAll('ipfs://ipfs/', '').replaceAll('ipfs://', '');
		if (PUBLIC_PINATA_GATEWAY_TOKEN) {
			return `${PUBLIC_IPFS_URL}${cid}?pinataGatewayToken=${PUBLIC_PINATA_GATEWAY_TOKEN}`;
		} else {
			return `${PUBLIC_IPFS_URL}${cid}`;
		}
	}
}

export function getAuctionImages(auction?: AuctionViewData) {
	return auction?.nfts?.flatMap(getNftImages) ?? [];
}

export function getNftImages(nft?: NftViewData): Image[] {
	const images =
		(nft?.files.filter(
			(file) => !file.mediaType || file.mediaType.startsWith('image/')
		) as Image[]) ?? [];

	if (nft && nft.imageUrl) {
		const match = images.find((image) => image.src === nft.imageUrl);
		if (!match) {
			const image: Image = {
				mediaType: nft.mediaType,
				name: nft.name,
				src: nft.imageUrl
			};
			images.push(image);
		}
	}

	return images;
}

export function getImageAlt(image: Image) {
	if (image.name) {
		return image.name;
	} else {
		return 'Gallery Image';
	}
}
